/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React, {CSSProperties, ReactNode} from 'react';
import {makeStyles} from '@material-ui/core/styles';

interface StableButtonLabelStyleProps {
  reserveFontWeight: number;
}

interface StableButtonLabelProps {
  children: ReactNode;
  className?: string;
  reserveFontWeight?: number;
  style?: CSSProperties;
}

const useStyles = makeStyles(() => ({
  root : {
    display      : 'inline-grid',
    alignItems   : 'center',
    justifyItems : 'center'
  },
  content : {
    gridArea : '1 / 1'
  },
  reserve : {
    gridArea      : '1 / 1',
    fontWeight    : ({reserveFontWeight}: StableButtonLabelStyleProps) => reserveFontWeight,
    pointerEvents : 'none',
    userSelect    : 'none',
    visibility    : 'hidden'
  }
}));

/**
 * Reserves space for the heaviest button label state so hover, active, and selected
 * font-weight changes do not alter the button's intrinsic width.
 */
export const StableButtonLabel = ({
  children,
  className,
  style,
  reserveFontWeight = 600
}: StableButtonLabelProps) => {
  const classes = useStyles({reserveFontWeight});

  return (
    <span className={`${classes.root}${className ? ` ${className}` : ''}`} style={style}>
      <span className={classes.content}>
        {children}
      </span>
      <span className={classes.reserve} aria-hidden='true'>
        {children}
      </span>
    </span>
  );
};

export default StableButtonLabel;
